import React from "react";
import { Alert, Button, CalendarDate, Card, CardHeader, Edit01, Zap } from "@opendate-app/setlist";

import { useBroadcastEditContext } from "./BroadcastEditContainer";

const styles = {
  field: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 6,
  },
  label: {
    color: "var(--sl-text-secondary)",
    fontSize: 14,
    fontWeight: 500,
  },
  recipients: {
    width: "100%",
    maxWidth: 320,
  },
  count: {
    color: "var(--sl-text-primary)",
    fontSize: 24,
    fontWeight: 600,
  },
  caption: {
    color: "var(--sl-text-tertiary)",
    fontSize: 14,
  },
  bestPractice: {
    marginTop: 16,
  },
};

export const DeliveryDateField = () => {
  const {
    broadcast,
    scheduledSend,
    previouslySent,
    setScheduledSendPaneOpen,
    formatDate,
  } = useBroadcastEditContext();

  const deliveryDate = broadcast.pending_scheduled_send ? formatDate(scheduledSend.scheduled_at) : "Select date";

  return (
    <div style={styles.field}>
      <span style={styles.label}>Delivery date & time</span>
      <Button
        icon={CalendarDate}
        disabled={previouslySent}
        aria-label={`Delivery date & time: ${deliveryDate}`}
        onClick={() => setScheduledSendPaneOpen(true)}
      >
        {deliveryDate}
      </Button>
    </div>
  );
};

export const RecipientsSummary = ({ bestPracticeText }) => {
  const {
    broadcast,
    recipientsCount,
    setTab,
  } = useBroadcastEditContext();

  const allFans = broadcast.recipient_type === "all_fans";

  return (
    <div style={styles.field}>
      <span style={styles.label}>Recipients</span>
      {recipientsCount !== "--" ? (
        <Card
          style={styles.recipients}
          header={
            <CardHeader
              title={allFans ? "All fans" : "Segment filtered fans"}
              actions={
                <Button
                  variant="tertiary"
                  size="xs"
                  icon={Edit01}
                  aria-label="Edit recipients"
                  onClick={() => setTab("recipients")}
                />
              }
            />
          }
        >
          <div style={styles.count}>{recipientsCount}</div>
          <div style={styles.caption}>
            {allFans ? "Total fans in this workspace" : "Total fans matching conditions"}
          </div>
          {allFans ? (
            <div style={styles.bestPractice}>
              <Alert color="brand" icon={Zap} title="Best Practices" description={bestPracticeText} />
            </div>
          ) : null}
        </Card>
      ) : null}
    </div>
  );
};
